import { analytics } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { LinkButton, Text, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { useDidUpdateEffect } from '../../custom-hooks/useDidUpdateEffect';
import { ProductCardLayoutType } from '../../common/models/product';
import { getPriceProps } from '../../common/utils/productCardProps';
import { SEAT_MAP } from '../../products';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { getMinPrice } from '../utils/selection';
import { useProductData } from '../../common/hook/useProductData';
import { useDynamicIcon } from '../../common/utils/dynamic-icons/useDynamicIcon';
import { DYNAMIC_ICON } from '../../common/utils/dynamic-icons/icons';
import { SEAT_MAP_DIALOG_ID } from '../constants/modal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  Main: MAIN_CARD_LAYOUT
} = ProductCardLayoutType;
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = SEAT_MAP;
const wrapperStyles = css`
  display: grid;
  grid-column-start: 2;
  justify-content: end;
`;
const iconStyles = content => css`
  content: ${content};
  display: grid;
  grid-row-start: 1;
  height: 18px;
`;
const linkButtonStyles = css`
  display: flex;
  grid-row-start: 1;
`;
const SeatMapProductCard = ({
  bounds,
  form,
  isSeatMapModalOpen,
  isSelected,
  order,
  priceRaw,
  setIsSeatMapModalOpen
}) => {
  const {
    t
  } = useTranslation();
  const [icon] = useDynamicIcon(vars.colors.links.default, DYNAMIC_ICON.editIcon);
  const {
    productData
  } = useProductData({
    form,
    isSelected,
    layoutType: MAIN_CARD_LAYOUT,
    order: order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    texts: {
      readMoreContent: 'seatMapReadMoreContent',
      title: 'seatMapTitle',
      additionalInformation: 'seatMapAdditionalInformation',
      abstractContent: 'seatMapDescription'
    }
  });
  useDidUpdateEffect(() => {
    let timeoutId;
    if (!isSelected) {
      timeoutId = setTimeout(() => {
        var _document$querySelect;
        (_document$querySelect = document.querySelector('#seatMap_false')) === null || _document$querySelect === void 0 || _document$querySelect.focus();
      }, 300);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [isSelected]);
  if (!productData) {
    return null;
  }
  const productPrice = isSelected ? priceRaw : getMinPrice(bounds);
  const productOptions = {
    priceRaw: productPrice
  };
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSelected, productOptions);
  const updatedProductData = {
    ...productData,
    extraProps: {
      ...productData.extraProps,
      onButtonChange: value => {
        if (value === 'true') {
          setIsSeatMapModalOpen(true);
          analytics.pushToDataLayer({
            event: 'seatingVisible',
            seatingOnPage: 'YES'
          });
        }
      }
    },
    price,
    priceLabel,
    priceRaw: productPrice,
    priceSuffix
  };
  return /*#__PURE__*/_jsx(ProductLayout, {
    productData: updatedProductData,
    children: isSelected && /*#__PURE__*/_jsx("div", {
      className: wrapperStyles,
      children: /*#__PURE__*/_jsxs(LinkButton, {
        "aria-controls": SEAT_MAP_DIALOG_ID,
        "aria-expanded": isSeatMapModalOpen,
        "aria-haspopup": "dialog",
        className: linkButtonStyles,
        "data-testid": "seatMapChangeSelection-button",
        onClick: () => setIsSeatMapModalOpen(true),
        children: [/*#__PURE__*/_jsx("span", {
          "aria-hidden": "true",
          className: iconStyles(icon),
          "data-testid": "edit-icon"
        }), /*#__PURE__*/_jsx(Text, {
          children: t('Product.SeatMap.Change')
        })]
      })
    })
  });
};
export default SeatMapProductCard;
//# sourceMappingURL=SeatMapProductCard.js.map